"use strict";

import { initModal } from "../core";

export const initQuiz = async (selector) => {
    const section = document.querySelector(selector);
    if (!section) return;
    const MODAL_CLASS = '.modal--quiz';
    const forms = section.querySelectorAll('form');
    const modal = section.querySelector(MODAL_CLASS);
    const bubbleTabs = section.querySelectorAll(`${selector}__bubble-content .tab-pane`);
    const stepsWrapper = section.querySelector(`${selector}__steps`);
    const steps = section.querySelectorAll(`${selector}__step`);

    const sectionId = section.getAttribute('id');
    const scoreBar = section.querySelector(`${selector}__score-bar`);
    const scoreResult = section.querySelector(`${selector}__score-result`);

    const correctFeedback = modal.querySelector(`${selector}__result--correct`);
    const incorrectFeedback = modal.querySelector(`${selector}__result--incorrect`);

    const restartButton = section.querySelector('.btn-restart-quiz');

    const answers = section.querySelectorAll(`${selector}__answer`);

    const scoreTracker = {};

    function getQuizScore() {
        return scoreTracker;
    }

    window.getQuizScore = getQuizScore;

    forms.forEach((form, index) => {
        form.reset();
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const correctAnswer = form.querySelector(`${selector}__option-input--correct`);
            const selectedOption = form.querySelector(`${selector}__option-input:checked`);
            const asweredCorrectly = correctAnswer === selectedOption;
            if (asweredCorrectly) {
                correctFeedback.classList.add('active');
                incorrectFeedback.classList.remove('active');
                scoreTracker[index] = { correct: true };
            } else {
                correctFeedback.classList.remove('active');
                incorrectFeedback.classList.add('active');
                scoreTracker[index] = { correct: false };
            }
            answers[index].classList.add('active');
            initModal(MODAL_CLASS, true);        
            modal.setAttribute('data-question-index', index);
        });
    });

    modal.addEventListener('hide.bs.modal', (e) => {
        let questionIndex = modal.getAttribute('data-question-index');
        if(!questionIndex) return;
        // Parse the index to an integer
        questionIndex = parseInt(questionIndex);
        const activeTab = section.querySelector(`${selector}__bubble-content .tab-pane.active`);
        if(activeTab) activeTab.classList.remove('active', 'show');
        const activeStep = section.querySelector(`${selector}__step.active`);
        if(activeStep) activeStep.classList.remove('active');
        bubbleTabs[questionIndex + 1].classList.add('active', 'show');
        if(steps[questionIndex + 1]) {
            steps[questionIndex + 1].classList.add('active');
        } else {
            stepsWrapper.classList.add('d-none');
            const scoreFraction = Object.values(scoreTracker).filter(item => item.correct).length / Object.keys(scoreTracker).length;
            if(scoreBar) scoreBar.style.setProperty('--score', parseFloat(scoreFraction.toFixed(2)));
            if(scoreResult) scoreResult.textContent = `${Object.values(scoreTracker).filter(item => item.correct).length}/${Object.keys(scoreTracker).length}`;
        }
    })

    // Cleanup active states on modal close
    modal.addEventListener('hidden.bs.modal', (e) => {
        const activeAnswer = section.querySelector(`${selector}__answer.active`);
        if (activeAnswer) {
            activeAnswer.classList.remove('active');
        }
    })

    if(restartButton) {
        restartButton.addEventListener('click', () => {
            window.location.href = `#${sectionId}`;
            location.reload();
        });
    }
};